<template>
	<vxe-modal v-model="modal" width="1200" height="800" @show="show" @hdie="hide" :title="title" destroy-on-close
		:showFooter="true">
		<template #default>
			<vxe-toolbar>
				<template #buttons>
					<vxe-button @click="salemanscoreExport">导出</vxe-button>
				</template>
			</vxe-toolbar>
			<vxe-table ref="salemanscore" footer-cell-class-name="footerCellColor" :show-footer="true" border
				show-overflow height="450" :data="data">
				<vxe-column type="seq" width="60"></vxe-column>
				<vxe-column field="targetname" title="客服名称"></vxe-column>
				<vxe-column field="score" title="积分"></vxe-column>
				<vxe-column field="name" title="积分名称"></vxe-column>
				<vxe-column field="mark" title="备注"></vxe-column>
				<vxe-column field="commit_time" title="获取时间">
					<template #default="{ row }">
						<span>{{$systemMethods.timestampToDate(row.commit_time)}}</span>
					</template>
				</vxe-column>
			</vxe-table>
		</template>
		<template #footer>
			<vxe-button status="" content="返回" @click="cancel"></vxe-button>
		</template>
	</vxe-modal>

</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			title: {
				type: String,
				default: () => {
					return '积分详情'
				}
			},
			currentrow: {
				default: () => {
					return null
				}
			},
			commit_time: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal: false,
				loading: false,
				tableData: [],
				data: [],

			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			cancel() {
				this.modal = false
			},
			hide() {
				this.$emit('hide')

			},
			show() {
				this.data = []
				this.$api.salemanscore.detail({
					commit_time: this.commit_time,
					targetname: this.currentrow.targetname
				}).then((res) => {
					this.data = res
				})
			},
			salemanscoreExport() {
				this.$refs.salemanscore.exportData({
					type: 'xlsx'
				})
			},
			modalShow() {
				this.modal = true
			}
		},
		components: {

		}
	}
</script>